import React from 'react';
import { MentalCapacityAssessmentType } from '../utils';

interface MentalCapacityAssessmentFormProps {
  mentalCapacityAssessment: MentalCapacityAssessmentType;
  setMentalCapacityAssessment: React.Dispatch<
    React.SetStateAction<MentalCapacityAssessmentType>
  >;
}

const CapacityAssessmentEntry: React.FC<MentalCapacityAssessmentFormProps> = ({
  mentalCapacityAssessment,
  setMentalCapacityAssessment,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="mental-capacity-assessment"
        >
          Mental capacity assessment
        </label>
      </h1>
      <div id="mental-capacity-assessment-hint" className="govuk-hint">
        If a mental capacity assessment of the (adult) person has been
        undertaken, what is the outcome of the assessment. Also record best
        interests decision if person lacks capacity.
      </div>
      <textarea
        className="govuk-textarea"
        id="mental-capacity-assessment"
        name="mentalCapacityAssessment"
        rows={5}
        aria-describedby="mental-capacity-assessment-hint"
        value={mentalCapacityAssessment.capacityAssessmentEntry}
        onChange={e => {
          setMentalCapacityAssessment(prev => ({
            ...prev,
            capacityAssessmentEntry: e.target.value,
          }));
        }}
      />
    </div>
  );
};

export default CapacityAssessmentEntry;
